import { ClarionCallout } from '@clarion/ClarionCallout';
import { ClarionCard } from '@clarion/ClarionCard';
import { H1, H2 } from '@clarion/Typography';
import RecapLogo from '../shared/RecapLogo';
import { useUserState } from './UserState';

export default function NoWorkspacePage() {
  const { user } = useUserState();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-transparent flex flex-col items-center justify-center p-4 md:p-8">
      <div className="max-w-2xl w-full text-center">
        <div className="mb-8">
          <RecapLogo iconOnly className="mx-auto mb-6" height="64" width="64" />
          <H1 className="mb-4">Welcome to Recap!</H1>
          <p className="text-sm opacity-80 leading-relaxed text-balance">
            Recap makes it easy to transcribe audio and video content, generate audio descriptions
            and translations, and collaborate with your team—all in one place.
          </p>
        </div>

        <ClarionCard className="p-8 mb-8 motion-safe:animate-fade-in-up">
          <H2 className="mb-4">You’re almost ready to get started 🚀</H2>

          <div className="text-left space-y-8">
            <p>
              Hi {user?.displayName || user?.email}! Your account has been created successfully, but
              you need to join a workspace to continue using Recap.
            </p>

            <p>
              <strong>Next steps:</strong>
            </p>

            <ol className="list-decimal space-y-2 ml-6">
              <li>
                Check for an email sent to <strong>{user?.email}</strong> containing an invitation
                to join a workspace on Recap Innovations
              </li>
              <li>
                Click the <strong>Accept Invite</strong> link in that email
              </li>
              <li>Start audio describing, captioning, and transcribing your content!</li>
            </ol>

            <ClarionCallout intent="primary" icon="help" title="Haven’t received an email?">
              Please contact your workspace administrator to send you a new invitation.
            </ClarionCallout>
          </div>
        </ClarionCard>
      </div>
    </div>
  );
}
